/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CommandDto } from '../models/CommandDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CommandControllerService {

    /**
     * @param name
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static executeCommand(
        name: string,
        requestBody: CommandDto,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/commands/{name}',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
